import { useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './css/login.css'

import Popup from "../components/Popup";
import { AppContext } from "../../Context";
import Fetch, { Loader,  user_login } from "../inc/Fetch";
import { GoogleLogin } from "../components/Elements";
import { Input } from "../components/Form";

export default function Login() {
	
	const { t } = useTranslation();
	let navigate = useNavigate();
	const location = useLocation();

	
	const {siteData, successData, user} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
	const [success, setsuccess] = successData;
	const [userinfo, setuserinfo] = user;


	const [loader, setloader] = useState(false);
	const [values, setvalues] = useState({});


	async function submit(e) {
		e.preventDefault();

		setloader(true);
		
		let r = await Fetch("reg", values);
		console.log(r);
		if (r?.error) {
			setsuccess({ short: t("error",  { returnObjects: true })[r?.error], error: true });
		} else {

			setsuccess({ short: t("login_success") });
			setuserinfo(r?.userinfo);

			setTimeout(() => {
				navigate(-1);
			}, 2500);

		}

		setloader(false);
		
	}

	useEffect(() => {
		if (location?.state?.data?.email) {

			setvalues({ email:location?.state?.data?.email, name: location?.state?.data?.name, img: location?.state?.data?.picture });
		}
	}, [location?.state?.data?.email])
	
	

	return (
		<>
			{loader && <Loader />}
			<Popup 
				className="loginPopBox reg"
			>
				<div className='leftLogin'>
					<h1>{t("reg_title")}</h1>
					<p>{t("reg_desc")}</p>
				</div>
				<form onSubmit={submit} className='loginForm'>

					<div className='loginFormIn'>
						<Input
							// title="email"
							placeholder={`${t("reg_fullname")}..`}
							type="name"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									name: v
								}))
							}
							value={values?.name}
						/>

						<Input
							// title="email"
							placeholder={`${t("reg_email")}..`}
							type="email"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									email: v
								}))
							}
							value={values?.email}
						/>

						<Input
							// title="email"
							placeholder={`${t("phone")}..`}
							type="number"
							onChange={(v) => 
								setvalues(p => ({
									...p,
									phone: v
								}))
							}
							value={values?.phone}
						/>

						<Input
							// title="Password"
							type="password"
							placeholder={`${t("login_pass")}..`}
							onChange={(v) => 
								setvalues(p => ({
									...p,
									pass: v
								}))
							}
						/>

						

						<Input
							// title="Password"
							type="password"
							placeholder={`${t("reg_pass_conf")}..`}
							onChange={(v) => 
								setvalues(p => ({
									...p,
									pass2: v
								}))
							}
						/>

						<div className='loginButtonBox'>
							<button className='btn login'>{t("reg")}</button>
						</div>
						

						
					</div>

					<div className='loginOr'>
						<span>{t("or")}</span>
						<hr />
					</div>


					<GoogleLogin redirect={"/"}/>
					

				</form>

				

			</Popup>
			
		</>
	)
}
